var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 29,
    viewBox: "0 0 39 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M18.5974 27.9963L0.541994 2.20283C-0.107528 1.27495 0.556286 -1.32834e-05 1.68892 -1.32339e-05L37.1444 -1.16841e-05C38.277 -1.16346e-05 38.9409 1.27495 38.2913 2.20284L20.2359 27.9963C19.8378 28.565 18.9955 28.565 18.5974 27.9963Z",
    fill: "#FE004E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVTriangle);
export default __webpack_public_path__ + "static/media/V-Triangle.21c7bf1555f27920e272972d49d65e59.svg";
export { ForwardRef as ReactComponent };